import { CreditCard, PaymentForm } from 'react-square-web-payments-sdk';
import usePublicPostApi from '~/public/lib/usePublicPostApi.js';
import useSharedPostApi from '~/lib/useSharedPostApi.js';

const SquarePaymentForm = ({
    type,
    id,
    paymentSettings,
    paymentBtnLabel,
    paymentElementContainerClassName,
}) => {
    const { save, isSaving } = useSharedPostApi(
        `/payments/payment-intent/${paymentSettings.paymentIntent.intentToken}`,
    );
    function onTokenized(token, verifiedBuyer) {
        console.log('token=', token);
        console.log('verifiedBuyer=', verifiedBuyer);
        save({
            paymentToken: token,
        }).then(result => {
            const url = new URL(paymentSettings.returnUrl);
            url.searchParams.append('payment_intent', result.token);
            document.location.href = url.toString();
        });
        /**
         * Process payment:
         * - Redirect to paymentSettings.returnUrl
         * - pass `payment_intent` as a param
         *
         * maybe locally create a square_payment_intents table?
         *  square_payment_intents:
         *      - id
         *      - amount
         *      - payment_token
         *      - settings
         * that stores the amount intended to pay, then pass this
         * then here we submit the token to be saved with the payment intent
         */
    }

    return (
        <div className="mt-4">
            <PaymentForm
                applicationId={paymentSettings?.paymentIntent?.applicationId}
                cardTokenizeResponseReceived={onTokenized}
                locationId={paymentSettings?.accountId}
            >
                <CreditCard>{paymentBtnLabel}</CreditCard>
            </PaymentForm>
            {!!paymentSettings?.paymentIntent?.vault && (
                <div className="text-gray-500 text-sm mt-2 leading-tight">
                    By providing your card information, you allow your card to
                    be charged for future payments in accordance with payment
                    terms.
                </div>
            )}
        </div>
    );
};

export default SquarePaymentForm;
